// extracted by mini-css-extract-plugin
export default {"container":"style_container__KKolG","backgroundImg":"style_backgroundImg__RaVwm","titleBox":"style_titleBox__UsEw6"};